import { makeStyles } from "@material-ui/core";


export const useLightStyles = makeStyles(() => ({
  body: {
    marginTop: 0,
    marginBottom: 0,
    // "& .Mui-checked + .MuiSwitch-track": {
    //   backgroundColor: "#fe8034",
    // },
    // "& .Mui-checked .MuiSwitch-thumb": {
    //   backgroundColor: "#fe8034",
    // },
    "& .Mui-selected": {
      backgroundColor: "rgba(169, 169, 169, 0.2) !important",
    },
  },
  listItemText: {
    fontWeight: "bold",
  },
  h2: {
    fontSize: "2rem",
    fontWeight: "bold",
  },
  innerList: {
    marginLeft: 60,
    "& > span": {
      fontSize: "0.85rem",
    },
  },
  userDetails: {
    // marginLeft: 60,
    marginTop: `-0.5rem`,
    marginBottom: `-0.5rem`,
  },
  header: {
    fontFamily: "roboto",
    fontSize: "0.85rem",
    padding: 0,
    width: '100%',
    minWidth: 250,
    // paddingLeft: 20
  },
  text: {
    "& div": {
      height: 24,
      paddingLeft: 0,
      width: '100%',
      minWidth: 178,
    },
    "& input": {
      paddingLeft: 2,
      outline: 0
    }
  },   
  // for legacy UI switch
    switchBase: {
      color: '#ff8c00',
      '&$checked': {
        color: '#ff8c00',
      },
      '&$checked + $track': {
        backgroundColor: '#ff8c00',
      },
    },
    checked: {},
    track: {},
}));
export const useDarkStyles = makeStyles(() => ({
  // for legacy UI switch
  switchBase: {
    color: '#ff8c00',
    '&$checked': {
      color: '#ff8c00',
    },
    '&$checked + $track': {
      backgroundColor: '#ff8c00',
    },
  },
  checked: {},
  track: {},
  body: {
    marginTop: 0,
    marginBottom: 0,
    color: "white",
    // "& .Mui-checked + .MuiSwitch-track": {
    //   backgroundColor: "#fe8034",
    // },
    // "& .Mui-checked .MuiSwitch-thumb": {
    //   backgroundColor: "#fe8034",
    // },
    "& .MuiListItem-root.Mui-selected": {
      backgroundColor: "rgba(169, 169, 169, 0.64) !important",
    },
    "& .MuiDivider-root": {
      backgroundColor: "rgba(255, 255, 255, 0.08)",
    },
    "& .MuiListItemIcon-root": {
      color: "white !important",
    },
    "& input": {
      color: "white",
    },
  },
  listItemText: {
    fontWeight: "bold",
  },
  h2: {
    fontSize: "2rem",
    fontWeight: "bold",
  },
  innerList: {
    marginLeft: 60,
    "& > span": {
      fontSize: "0.85rem",
    },
  },
  userDetails: {
    // marginLeft: 60,
    marginTop: `-0.5rem`,
    marginBottom: `-0.5rem`,
  },
  header: {
    fontFamily: "roboto",
    fontSize: "0.85rem",
    padding: 0,
  },
  text: {
    "& div": {
      height: 24,
      width: 180,
      textAlign: "start",
    },
  },
}));